import styled from "styled-components";

export const StyledMarketCard = styled.div`
    border-top: 1px solid ${({ theme }) => theme.disabledTypographyColor};
    padding: 8px;

    &:last-child {
        border-bottom: 1px solid ${({ theme }) => theme.disabledTypographyColor};
    }
`;
